angular
  .module('subscriptionProduct')
  .component('subscriptionProduct', {
    template: require('./subscription-product.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function SubscriptionProductViewController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $rootScope.mainmenu = 'service';
        $rootScope.menu = 'subscriptionProduct';
        const APIURL = envService.read('apiUrl'); // eslint-disable-line
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        $resource(`${APIURL}/admin/subscription/products`).get({ page: 0 }).$promise
          .then((data) => {
            this.groups = data.groups;
            this.types = data.types;
            this.rowSpan = this.types.length;
          })
          .catch((err) => {
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        this.deleteGroup = (group) => {
          if (!confirm($translate.instant('정말로 삭제하시겠습니까?'))) {
            return;
          }
          $resource(`${APIURL}/admin/subscription/products/:id`, { id: group.ID }).delete().$promise
            .then(() => {
              this.groups = this.groups.filter(item => item !== group);
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.openModifyPopup = (group) => {
          this.modifyGroup = $.extend({}, group);
          jQuery('#modal-modify').modal('show');
        };
        this.modifySubmit = () => {
          $resource(`${APIURL}/admin/subscription/groups`).save(this.modifyGroup).$promise
            .then(() => {
              this.groups = this.groups.map((group) => {
                if (group.ID === this.modifyGroup.ID) {
                  return this.modifyGroup;
                }
                return group;
              });
              jQuery('#modal-modify').modal('hide');
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this.getRowSpan = (group) => {
          const repeatTypes = [];
          const repeatCount = group.products.reduce((acc, val) => {
            if (!repeatTypes.includes(val.REPEAT_TYPE)) {
              repeatTypes.push(val.REPEAT_TYPE);
            }
            return repeatTypes.length;
          }, repeatTypes);
          return Math.min(group.products.length / repeatCount, this.types.length);
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/subscription-product/subscription-product.component.js